module.exports = __webpack_public_path__ + "img/blindaje-derecha.967fa422.jpg";